module.exports = __webpack_public_path__ + "static/media/ascensore.9889f1ae.mp4";